export const preloadExports = [
  //ui icons
  require("./bm-swamp3.png").default,
  require('./square-button-feather.png').default,
  require('./pix-grad1.png').default,
  require('./play.svg').default,
  require('./neonArtboard 1@4x.png').default,
  require('./arrow.svg').default,
  require('./greenarrow.svg').default,
]